import PanelWrapper from './PanelWrapper';

export default PanelWrapper;
